export default function* processError(err) {
  yield window.console.error(err); // eslint-disable-line
}
